/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutomaticEmailStepOverrideEmailBodyDoc } from './automaticEmailStepOverrideEmailBodyDoc';
import type { AutomaticEmailStepOverrideEmailSubjectDoc } from './automaticEmailStepOverrideEmailSubjectDoc';
import type { AutomaticEmailStepOverrideEmailThreadMode } from './automaticEmailStepOverrideEmailThreadMode';

export interface AutomaticEmailStepOverride {
  type: 'automatic_email';
  email_subject_doc?: AutomaticEmailStepOverrideEmailSubjectDoc;
  email_body_doc?: AutomaticEmailStepOverrideEmailBodyDoc;
  email_thread_mode?: AutomaticEmailStepOverrideEmailThreadMode;
  email_cc?: string[] | null;
  email_bcc?: string[] | null;
  email_include_sender_signature?: boolean | null;
  email_to_address?: string | null;
}
